module.exports = __webpack_public_path__ + "assets/img/caption.9fb9bb00.png";